/* @flow */

import { callApiEndpoint } from './index';
import utils from './utils';

import type { Broadcasting } from 'types';

const find = async (): Promise<Broadcasting[]> => {
  const response = await callApiEndpoint('usermanagement/getUserEmittenti', {
    params: {},
  });
  return response.map(utils.toBroadcasting);
};

export default {
  find,
};
